export function hasPanelPermission({ userType, permissions }, key) {
  if (!key || userType === "admin") return true;

  return Array.isArray(permissions) && permissions.includes(key);
}
